/**
 * Decode the email claim from a JWT id_token WITHOUT verifying the signature.
 * For DISPLAY ONLY (prefilling the password-once prompt). Auth is done server-side.
 * Never trust this value for access control.
 */
export function decodeJwtEmail(idToken: string): string | null {
  try {
    if (!idToken || typeof idToken !== 'string') return null;
    const parts = idToken.split('.');
    if (parts.length < 2) return null;
    const payload = parts[1];
    // base64url → base64
    const b64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    const claims = JSON.parse(json) as Record<string, unknown>;
    const email = claims['email'];
    if (typeof email === 'string' && email.length > 0) return email;
    return null;
  } catch {
    return null;
  }
}
